(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobile = window.matchMedia('(width < 750px)');
    const sync = () => {
      document.querySelectorAll('.menu-block__accordion').forEach((details) => {
        details.open = !mobile.matches;
      });
    };
    sync();
    mobile.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
